export default __webpack_public_path__ + "static/media/brand_image-sign-up.0bb1af50.png";